// @ts-check
import React from 'react';

/** @typedef {{
  errors?: string[] | string,
  render?: (errors: string[]) => JSX.Element
}} ErrorsProps */

/** @type { React.SFC<ErrorsProps> } */
const Errors = ({ errors = [], render = defaultRender }) => {
  errors = Array.isArray(errors) ? errors : [errors];
  return errors.length > 0 ? render(errors) : null;
};

const defaultRender = errors => (
  <div className="error_messages">
    <h5>Please correct the following:</h5>
    <ul>
      {errors.map((error, idx) => (
        <li key={idx}>{error}</li>
      ))}
    </ul>
  </div>
);

Errors.displayName = 'Errors';

export default Errors;
